import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/backend/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: AuthService, private router: Router) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn()) {
      if (state.url.indexOf('login') > 0) {
        this.authService.navigateToInitialMenu();
      }
      return true;
    }
    this.authService.redirectionURL = state.url;
    this.router.navigate(['/login']);
    return false;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.isLoggedIn()) {
      if (state.url !== '') {
        const hasAccess = this.authService.checkMenuAccess(state.url);
        if (hasAccess) {
          this.authService.redirectionURL = state.url;
          return true;
        }
        else {
          if (state.url !== '/not-found') {
            this.router.navigate(['/not-found']);
          }
          return false;
        }
      }
      return true;
    } else {
      this.authService.redirectionURL = state.url;
      this.router.navigate(['/login']);
      return false;
    }
  }
}
